<template>
  <v-card outlined rounded="lg" :loading="loading" class="pa-3 h-100">
    <div class="section-card-title">
      <v-icon color="#B3151B" class="mr-2">mdi-account-tie</v-icon>
      ผู้บริหารสถานศึกษา
    </div>

    <div class="d-flex flex-column align-center text-center pa-2">
      <v-avatar size="140" class="mb-3 director-avatar">
        <v-img
          :src="'https://hrvec.ovec.go.th/HRvecfiles/' + collegeinfo.collegeinfo_directorpic"
          contain
        ></v-img>
      </v-avatar>
      <div class="font-weight-bold">{{ collegeinfo.collegeinfo_director || "-" }}</div>
      <div class="grey--text text-caption">ผู้อำนวยการ{{ collegeinfo.college_name }}</div>
      <div v-if="collegeinfo.collegeinfo_directorphone" class="mt-2 text-caption">
        <v-icon x-small color="#B3151B">mdi-phone</v-icon>
        {{ collegeinfo.collegeinfo_directorphone }}
      </div>
    </div>
  </v-card>
</template>

<script>
// ดึงข้อมูลสถานศึกษา (collegeinfo.php) — เป็นเจ้าของข้อมูลชุดนี้แต่เพียงผู้เดียวในหน้า แล้วส่งต่อให้ parent
// (collegesid.vue) ผ่าน event "loaded" เพื่อใช้ประกอบหัวหน้าเพจ/สถิติสรุป/ส่งออก Excel โดยไม่ต้อง fetch ซ้ำ
export default {
  name: "DashboardOvecMasterCollegeDirector",

  data() {
    return {
      ApiKey: "HRvec2021",
      collegeinfo: {},
      loading: true
    };
  },

  async mounted() {
    await this.collegeinfoQuery();
  },

  methods: {
    async collegeinfoQuery() {
      try {
        this.loading = true;
        let result = await this.$http.post("collegeinfo.php", {
          ApiKey: this.ApiKey,
          collegeinfo_code: this.college_ID
        });
        this.collegeinfo = result.data || {};
        this.$emit("loaded", this.collegeinfo);
      } catch (error) {
        this.$emit("loaded", null);
      } finally {
        this.loading = false;
      }
    }
  },
  computed: {
    college_ID() {
      return this.$route.query.college_ID;
    }
  }
};
</script>

<style scoped>
.h-100 {
  height: 100%;
}
.section-card-title {
  display: flex;
  align-items: center;
  font-weight: 700;
  color: #1b365d;
  font-size: 1rem;
  margin-bottom: 8px;
}
.director-avatar {
  border: 3px solid #fdeeee;
}
</style>
